module.exports = __webpack_public_path__ + "media/images/friends-168a5b50633c73f827f78afdf63ea1bd.png";